<iframe
  [id]="'youtubeVideo' + index"
  [width]="width"
  [height]="height"
  [src]="path | SafeUrl"
  [title]="title"
  class="youtube-video"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  [attr.frameborder]="frameborder"
  allowfullscreen="1"
  [attr.enablejsapi]="enableJsApi ? '1' : '0'"></iframe>
